export default __webpack_public_path__ + "static/media/visa_image.b30bbd68.svg";